import Flex from "components/grid/Flex";
import _ from "lodash";
import { niagara } from "../../../../../components/colors/Colors";
import { useTranslation } from "react-i18next";
import { isContentFull } from "../../HistoryUtils";
import { Typography } from "@material-ui/core";
import Date from "./Date";

export function getContentFullArray(array) {
    return array
        ? array
              ?.filter(isContentFull)
              ?.map((item) => {
                  const row = _.cloneDeep(item);
                  const indexOfDate = row.indexOf(row.find((cell) => cell.question === "date"));
                  const dateRow = row.splice(indexOfDate, 1)[0];
                  const sortedRow = _.sortBy(row, ["question"]);
                  sortedRow.unshift(dateRow);
                  return sortedRow;
              })
              ?.sort((a, b) => {
                  const aDate = a.find((cell) => cell.question === "date")?.answer;
                  const bDate = b.find((cell) => cell.question === "date")?.answer;
                  return aDate?.localeCompare(bDate);
              })
        : [];
}

const SimpleArrayOfValues = ({ array, label, translationKey, questionsToTranslate = [] }) => {
    const { t } = useTranslation();
    const contentFullArray = getContentFullArray(array);
    return !_.isEmpty(contentFullArray) ? (
        <Flex item container column grow={0}>
            <Typography style={{ fontWeight: "bold" }}>{label}</Typography>
            <table
                style={{
                    border: `1px solid ${niagara}`,
                    borderSpacing: 0,
                    borderCollapse: "unset",
                    width: "100%",
                    marginTop: 10,
                }}
            >
                <tbody>
                    <tr>
                        {(contentFullArray?.[0] || [])?.map((row, index) => (
                            <th
                                key={"" + row.question + index}
                                style={{
                                    textAlign: "left",
                                    padding: 4,
                                    backgroundColor: "#dddddd",
                                    textTransform: "capitalize",
                                    borderRadius: "unset !important",
                                    borderBottom: "1px solid grey",
                                    color: "#626262",
                                }}
                            >
                                {row.question}
                            </th>
                        ))}
                    </tr>
                    {contentFullArray?.map((rows, index) => (
                        <tr key={"rows" + index}>
                            {rows.map((cell) => (
                                <td
                                    key={"" + cell.question + index}
                                    style={{
                                        textAlign: "left",
                                        padding: 4,
                                    }}
                                >
                                    {cell.question === "date" && <Date date={cell.answer} />}
                                    {cell.question !== "date" && (
                                        <>
                                            {translationKey && questionsToTranslate.includes(cell.question)
                                                ? t(`${translationKey}.${cell.answer}`).endsWith(".")
                                                    ? cell.answer
                                                    : t(`${translationKey}.${cell.answer}`)
                                                : cell.answer}
                                        </>
                                    )}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </Flex>
    ) : (
        <></>
    );
};

export default SimpleArrayOfValues;
